import { lazy, ComponentType, LazyExoticComponent } from 'react';

/**
 * React.lazy que reintenta el import dinámico si falla (p. ej. ChunkLoadError
 * transitorio). Tras agotar los reintentos propaga el último error.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  retries = 2,
  delayMs = 500
): LazyExoticComponent<T> {
  return lazy(async () => {
    for (let attempt = 0; ; attempt++) {
      try {
        return await factory();
      } catch (error) {
        if (attempt >= retries) throw error;
        await new Promise((resolve) => setTimeout(resolve, delayMs * (attempt + 1)));
      }
    }
  });
}
